import React from 'react';
import PropTypes from 'prop-types';

import {
  Display,
  Header,
  Content,
  Footer,
  HardwareButtonWrapper
} from 'containers';

import { HeaderText } from 'components';
import { ConfirmButton, CancelButton } from 'components/buttons';
import Label from 'containers/Label/Label';

const Confirmation = ({ content, callbacks }) => {
  const buttonConfig = {
    left: {
      onClick: callbacks.onConfirm
    },
    right: {
      onClick: callbacks.onCancel
    }
  };

  return [
    <Display key="display">
      <Header>
        <HeaderText value={content.title} />
      </Header>
      <Content>
        <Label name={content.text} />
      </Content>
      <Footer>
        <ConfirmButton />
        <CancelButton />
      </Footer>
    </Display>,
    <HardwareButtonWrapper key="buttons" config={buttonConfig} />
  ];
};

Confirmation.propTypes = {
  callbacks: PropTypes.shape({
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
  }).isRequired,
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  }).isRequired
};

export default Confirmation;



// WEBPACK FOOTER //
// ./src/screens/shared/Confirmation/Confirmation.js